function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback } from 'react';
import { VenueMapController } from '../../classes/VenueMapController/class';
import { DEFAULT_CLICK_BEHAVIOR, MAP_NOT_READY_ERROR, NUMERIC_PRECISION } from '../../constants';
var useState = React.useState,
  useEffect = React.useEffect,
  useRef = React.useRef;
function useVenueMapState(props) {
  var _map$metadata3;
  var layoutUrl = props.layoutUrl,
    _props$selectedSectio = props.selectedSections,
    selectedSections = _props$selectedSectio === void 0 ? [] : _props$selectedSectio,
    _props$onSectionSelec = props.onSectionSelectAction,
    onSectionSelectAction = _props$onSectionSelec === void 0 ? function () {} : _props$onSectionSelec,
    _props$sections = props.sections,
    sections = _props$sections === void 0 ? [] : _props$sections,
    onFilterResetAction = props.onFilterResetAction,
    currentSelectedSection = props.currentSelectedSection,
    onMapResetClickCallback = props.onMapResetClickCallback,
    _props$selectedRows = props.selectedRows,
    selectedRows = _props$selectedRows === void 0 ? [] : _props$selectedRows,
    _props$setSelectedRow = props.setSelectedRows,
    setSelectedRows = _props$setSelectedRow === void 0 ? function () {} : _props$setSelectedRow,
    padding = props.padding;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    mapElementState = _useState2[0],
    setMapElementState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mapInitialized = _useState4[0],
    setMapInitialized = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    map = _useState6[0],
    setMap = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSectionsMbi = _useState8[0],
    setSelectedSectionsMbi = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    mapMetadataLoaded = _useState10[0],
    setMapMetadataLoaded = _useState10[1];
  var mapElement = useCallback(function (node) {
    if (node === null) return;
    setMapElementState(node);
  }, []);
  useEffect(function () {
    if (!mapElementState) return;
    // Initialize the map
    if (typeof window === 'undefined') return;
    if (!layoutUrl) return console.error('No layout URL was specified.');
    if (!!mapElementState && sections) {
      var initMapStart = Date.now();
      var mapboxMap = new VenueMapController({
        activeCursor: false,
        parent: mapElementState !== null && mapElementState !== void 0 ? mapElementState : '',
        data: layoutUrl,
        sections: sections,
        padding: padding || 0
      });
      setMap(mapboxMap);
      setMapInitialized(true);
      mapboxMap.on('load', function () {
        // Update inspector
        updateInspectorProperties();
        updateInspectorSeatingState();
        updateInspectorLoadTime(Date.now() - initMapStart);
        setControlsActive(true);
      });
    }
  }, [mapElementState]);
  var mapPopup = useRef(null);
  var domNodes = {
    map: '#mapParent',
    // Panel
    controlPanel: {},
    controlPanelScroll: {},
    controlPanelToggle: {},
    // Forms
    enableAllSeatingButton: {},
    resetFocusButton: {},
    resetHighlightButton: {},
    resetMapButton: {},
    resetSeatingButton: {},
    setAvailableSeatingButton: {},
    setAvailableSeatingForm: {},
    setAvailableSeatingInput: {},
    setFocusButton: {},
    setFocusForm: {},
    setHighlightButton: {},
    setHighlightForm: {},
    setMapForm: {},
    setMapFormInput: {},
    // Properties
    bearing: {},
    center: {},
    colorSchema: {},
    maxZoom: {},
    minZoom: {},
    pitch: {},
    postion: {},
    rowZoom: {},
    zoom: {},
    // Metrics
    loadTime: {},
    // Seating State
    highlighted: {},
    hovered: {},
    selectedRows: {},
    selectedSections: {},
    visibleSeating: {},
    // Map Behavior
    animateCheckbox: {},
    faceStageCheckbox: {},
    focusCheckbox: {},
    mobileBackdrop: {},
    virtualCursorToggle: {}
  };
  // ensure code only runs on client side in ssr apps
  useEffect(function () {
    var _document, _document2, _document3;
    domNodes = _objectSpread(_objectSpread({}, domNodes), {}, {
      controlPanel: (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById('controlPanel'),
      controlPanelScroll: (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.getElementById('controlPanelScroll'),
      controlPanelToggle: (_document3 = document) === null || _document3 === void 0 ? void 0 : _document3.getElementById('controlPanelToggle')
    });
  }, []);
  var updateInspectorVisibleSeating = function updateInspectorVisibleSeating() {
    if (mapInitialized && map) {
      var visibleSections = map.getVisibleSeating('section', {
        available: true
      }).sort();
      var visibleRows = map.getVisibleSeating('row', {
        available: true
      }).sort();
      if (visibleSections.length) {
        domNodes.visibleSeating.innerHTML = visibleSections.map(function (s) {
          return "<li class=\"vdp-badge --lg\">".concat(s, "</li>");
        }).join('');
      } else if (visibleRows.length) {
        domNodes.visibleSeating.innerHTML = visibleRows.map(function (r) {
          return "<li class=\"vdp-badge --lg\">".concat(r, "</li>");
        }).join('');
      } else {
        domNodes.visibleSeating.innerHTML = '';
      }
    }
  };
  var setControlsActive = function setControlsActive(active) {
    var disabled = !active;
    domNodes.enableAllSeatingButton.disabled = disabled;
    domNodes.resetFocusButton.disabled = disabled;
    domNodes.resetHighlightButton.disabled = disabled;
    domNodes.resetMapButton.disabled = disabled;
    domNodes.resetSeatingButton.disabled = disabled;
    domNodes.setAvailableSeatingButton.disabled = disabled;
    domNodes.setFocusButton.disabled = disabled;
    domNodes.setHighlightButton.disabled = disabled;
    domNodes.virtualCursorToggle.disabled = disabled;
  };
  var updateInspectorCenter = function updateInspectorCenter() {
    if (!mapInitialized || !map) throw new Error(MAP_NOT_READY_ERROR);
    var mapCenter = map === null || map === void 0 ? void 0 : map.center;
    if (!mapCenter) throw new Error('Could not locate map center.');
    domNodes.center.innerText = "(".concat(mapCenter.lng.toFixed(NUMERIC_PRECISION), ", ").concat(mapCenter.lat.toFixed(NUMERIC_PRECISION), ")");
  };
  var updateInspectorPosition = function updateInspectorPosition() {
    if (!mapInitialized || !map) return null;
    var mapPosition = map.position;
    domNodes.postion.innerText = "(".concat(mapPosition.lng.toFixed(NUMERIC_PRECISION), ", ").concat(mapPosition.lat.toFixed(NUMERIC_PRECISION), ")");
  };
  var updateInspectorZoom = function updateInspectorZoom() {
    if (!mapInitialized || !map) return null;
    domNodes.zoom.innerText = map.zoom.toFixed(NUMERIC_PRECISION);
  };
  var updateInspectorRowZoom = function updateInspectorRowZoom() {
    if (!mapInitialized || !map) return null;
    domNodes.rowZoom.innerText = map.rowZoom.toFixed(NUMERIC_PRECISION);
  };
  var updateInspectorBearing = function updateInspectorBearing() {
    if (!mapInitialized || !map) return null;
    domNodes.bearing.innerText = map.bearing.toFixed(NUMERIC_PRECISION);
  };
  var updateInspectorPitch = function updateInspectorPitch() {
    if (mapInitialized && map) {
      domNodes.pitch.innerText = map.pitch.toFixed(NUMERIC_PRECISION);
    }
  };
  var updateInspectorLoadTime = function updateInspectorLoadTime(milliseconds) {
    var _domNodes;
    if (!((_domNodes = domNodes) !== null && _domNodes !== void 0 && _domNodes.loadTime)) return;
    domNodes.loadTime.innerText = "".concat((milliseconds / 1000).toFixed(2), "s");
  };
  var updateInspectorHovered = function updateInspectorHovered() {
    if (mapInitialized && map) {
      domNodes.hovered.innerText = map.hovered || '-';
    }
  };
  var updateInspectorHightlighted = function updateInspectorHightlighted() {
    if (mapInitialized && map) {
      domNodes.highlighted.innerText = map.highlight || '-';
    }
  };
  var updateInspectorSelectedSections = function updateInspectorSelectedSections() {
    var _domNodes2;
    if (!((_domNodes2 = domNodes) !== null && _domNodes2 !== void 0 && _domNodes2.selectedSections)) return;
    domNodes.selectedSections.innerHTML = selectedSections.map(function (r) {
      return "<button type=\"button\" class=\"vdp-chip\">\n                    ".concat(r, "\n                </button>");
    }).join('');
  };
  var updateInspectorSelectedRows = function updateInspectorSelectedRows() {
    if (!selectedRows.length) return;
    domNodes.selectedRows.innerHTML = selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.map(function (r) {
      return "<button type=\"button\" class=\"vdp-chip\">\n                    ".concat(r, "\n                </button>");
    }).join('');
  };

  // Map Events
  var onMapZoomEnd = function onMapZoomEnd(event) {
    if (!mapInitialized || !map) return null;
    clearMapPopup();
    updateInspectorBearing();
    updateInspectorPitch();
    updateInspectorPosition();
    updateInspectorZoom();

    // Let map finish rendering before querying
    setTimeout(function () {
      updateInspectorVisibleSeating();
    }, 0);
  };
  var onMapDragEnd = function onMapDragEnd(event) {
    clearMapPopup();
    updateInspectorPosition();
    updateInspectorVisibleSeating();
  };
  var highlightAllRowsForASection = function highlightAllRowsForASection(sectionsHighlight) {
    sectionsHighlight.forEach(function (section) {
      var sectionFiltered = sections.find(function (curr) {
        return curr.mbi === section.mbi;
      });
      if (!(sectionFiltered !== null && sectionFiltered !== void 0 && sectionFiltered.mbi)) return;
      sectionFiltered.rows.forEach(function (rowId) {
        if (!rowId) return;
        map === null || map === void 0 || map.setSelection("".concat(section.mbi, ":").concat(rowId), true);
      });
    });
  };
  var onMapSectionClick = function onMapSectionClick(event) {
    var detail = event.detail;
    if (!detail) return;
    var section = detail.section;
    if (!(section !== null && section !== void 0 && section.sectionId)) return;
    var sectionId = section.sectionId.replace(/\D/g, '');
    onSectionSelectAction === null || onSectionSelectAction === void 0 || onSectionSelectAction({
      id: "".concat(sectionId),
      hasSectionBeenManuallyFiltered: true
    });
    updateInspectorSelectedSections();
  };
  var onMapRowLeave = function onMapRowLeave() {
    if (!mapPopup) return;
    clearMapPopup();
    if (!map) return;
    map.setHighlight(null);
    updateInspectorHovered();
    updateInspectorHightlighted();
  };
  var onMapRowClick = function onMapRowClick(event) {
    if (!mapInitialized || !map) return null;
    var rowId = event.detail.row.id;
    setSelectedRows({
      rowId: rowId
    });
    map === null || map === void 0 || map.setSelection(rowId, !event.detail.featureState.selected);
    // select the section when someone clicks on row
    var _rowId$split = rowId.split(":"),
      _rowId$split2 = _slicedToArray(_rowId$split, 1),
      mbi = _rowId$split2[0];
    if (!mbi) return null;
    map === null || map === void 0 || map.setSelection(mbi, true);

    // prevent focus on section when the row is just clicked
    if (event.detail.setFocus) {
      map.setFocus(rowId, {
        animate: DEFAULT_CLICK_BEHAVIOR.animate,
        faceStage: DEFAULT_CLICK_BEHAVIOR.faceStage,
        persistFocusOptions: false
      });
    }
    updateInspectorSelectedRows();
  };
  var onMapRevertTicketSelectionZoom = function onMapRevertTicketSelectionZoom() {
    map === null || map === void 0 || map.revertToLastSelectedFeatureView();
  };
  var onMapResetClick = function onMapResetClick(options) {
    if (mapPopup) clearMapPopup();
    map === null || map === void 0 || map.setFocus(null, {
      animate: DEFAULT_CLICK_BEHAVIOR.animate,
      faceStage: DEFAULT_CLICK_BEHAVIOR.faceStage,
      persistFocusOptions: !(options !== null && options !== void 0 && options.resetFilters),
      reset: options === null || options === void 0 ? void 0 : options.resetFilters
    });
    // only continue if you are resetting filters
    if (!(options !== null && options !== void 0 && options.resetFilters)) return;
    onFilterResetAction === null || onFilterResetAction === void 0 || onFilterResetAction();
    sections.map(function (section) {
      map === null || map === void 0 || map.setSelection(section.mbi, false);
    });
    selectedRows.map(function (rowId) {
      map === null || map === void 0 || map.setSelection(rowId, false);
    });
    onMapResetClickCallback === null || onMapResetClickCallback === void 0 || onMapResetClickCallback();
  };
  var updateInspectorSeatingState = function updateInspectorSeatingState() {
    updateInspectorHightlighted();
    updateInspectorHovered();
    updateInspectorSelectedRows();
    updateInspectorSelectedSections();
    updateInspectorVisibleSeating();
  };
  var onMapSectionClickFromListing = function onMapSectionClickFromListing(_sectionId, mapboxId) {
    if (map) {
      map.setFocus(mapboxId, {
        animate: DEFAULT_CLICK_BEHAVIOR.animate,
        faceStage: DEFAULT_CLICK_BEHAVIOR.faceStage,
        persistFocusOptions: false
      });
    }
    updateInspectorSelectedSections();
  };
  var clearMapPopup = useCallback(function () {
    if (mapPopup.current) {
      mapPopup.current.remove();
      mapPopup.current = null;
    }
  }, []);
  var setSectionPriceTooltip = useCallback(function (props) {
    var _map$metadata;
    if (!map) return;
    clearMapPopup();
    var sectionId = props.sectionId;
    var section = sections.find(function (section) {
      return section.sectionId === sectionId;
    });
    if (!section) return;
    var mbi = section.mbi;
    var popupPosition = map === null || map === void 0 || (_map$metadata = map.metadata) === null || _map$metadata === void 0 || (_map$metadata = _map$metadata.sections) === null || _map$metadata === void 0 || (_map$metadata = _map$metadata[mbi]) === null || _map$metadata === void 0 ? void 0 : _map$metadata.center;
    if (!popupPosition) return console.log('No map center found for hovered section.');
    var customPopup = section === null || section === void 0 ? void 0 : section.hoverContent;
    var popupContent = customPopup !== null && customPopup !== void 0 ? customPopup : "<b>$".concat(section === null || section === void 0 ? void 0 : section.price, "</b>");
    map === null || map === void 0 || map.setHighlight(mbi);
    mapPopup.current = map.addPopup(popupPosition, popupContent);
    updateInspectorHovered();
  }, [sections.toString(), clearMapPopup, map]);
  var onMapSectionHover = function onMapSectionHover(event) {
    if (!map) return;
    var section = sections.find(function (section) {
      return section.sectionId === event.detail.section.sectionId;
    });
    var popupPosition = event.detail.sectionGeometryMeta.center;
    var customPopup = section === null || section === void 0 ? void 0 : section.hoverContent;
    var popupContent = customPopup !== null && customPopup !== void 0 ? customPopup : "<b>$".concat(section === null || section === void 0 ? void 0 : section.price, "</b>");
    var sectionMBIId = event.detail.section.mbi;
    map.setHighlight(sectionMBIId);
    clearMapPopup();
    mapPopup.current = map.addPopup(popupPosition, popupContent);
    updateInspectorHovered();
  };
  var onMapSectionLeave = function onMapSectionLeave() {
    if (!map) return;
    clearMapPopup();
    map.setHighlight(null);
    updateInspectorHovered();
  };
  var onMapRowHover = function onMapRowHover(event) {
    var _section$availableRow, _rowData$tooltip;
    if (!event.detail.featureState.available || !map) return;
    var _String$split = String(event.detail.row.id).split(':'),
      _String$split2 = _slicedToArray(_String$split, 2),
      sectionMbi = _String$split2[0],
      rowId = _String$split2[1];
    if (!sectionMbi || !rowId) return;
    var section = sections.find(function (section) {
      return section.mbi === sectionMbi;
    });
    var rowData = section === null || section === void 0 || (_section$availableRow = section.availableRowsData) === null || _section$availableRow === void 0 ? void 0 : _section$availableRow[rowId.toUpperCase()];
    var popupPosition = event.detail.sectionGeometryMeta.rows[event.detail.row.name].center;
    var popupContent = (_rowData$tooltip = rowData === null || rowData === void 0 ? void 0 : rowData.tooltip) !== null && _rowData$tooltip !== void 0 ? _rowData$tooltip : "From <b>".concat(rowData === null || rowData === void 0 ? void 0 : rowData.minPrice, "</b>");
    clearMapPopup();
    mapPopup.current = map.addPopup(popupPosition, popupContent);
    map.setHighlight(event.detail.row.id);
    updateInspectorHovered();
  };
  var updateInspectorMaxZoom = function updateInspectorMaxZoom() {
    if (!mapInitialized || !map) return null;
    domNodes.maxZoom.innerText = map.maxZoom.toFixed(NUMERIC_PRECISION);
  };
  var updateInspectorMinZoom = function updateInspectorMinZoom() {
    if (!mapInitialized || !map) return null;
    domNodes.minZoom.innerText = map.minZoom.toFixed(NUMERIC_PRECISION);
  };
  var updateInspectorProperties = function updateInspectorProperties() {
    if (map) {
      updateInspectorBearing();
      updateInspectorCenter();
      updateInspectorMaxZoom();
      updateInspectorMinZoom();
      updateInspectorPitch();
      updateInspectorPosition();
      updateInspectorRowZoom();
      updateInspectorZoom();
    }
  };

  // Cleanup state on component unmount
  useEffect(function () {
    return function () {
      setMapInitialized(false);
      setMap(undefined);
      setControlsActive(false);
    };
  }, []);
  useEffect(function () {
    map === null || map === void 0 || map.on('load', function () {
      map.on('section-click', onMapSectionClick);
      map.on('row-click', onMapRowClick);
      map.on('dragend', onMapDragEnd);
      map.on('reset-click', onMapResetClick.bind(null, {
        resetFilters: true
      }));
      map.on('row-hover', onMapRowHover);
      map.on('row-leave', onMapRowLeave);
      map.on('section-hover', onMapSectionHover);
      map.on('section-leave', onMapSectionLeave);
      map.on('zoomend', onMapZoomEnd);
      // sync persisted map sections on map load
      map === null || map === void 0 || map.syncSelectedSections(selectedSectionsMbi.map(function (s) {
        return s.mbi;
      }));
      map === null || map === void 0 || map.syncSelectedRows(selectedRows);
      highlightAllRowsForASection(selectedSectionsMbi);
      setMapMetadataLoaded(!!(map !== null && map !== void 0 && map.metadata));
    });
    return function () {
      map === null || map === void 0 || map.off('load', function () {
        map.off('section-click', onMapSectionClick);
        map.off('row-click', onMapRowClick);
        map.off('dragend', onMapDragEnd);
        map.off('reset-click', onMapResetClick.bind(null, {
          resetFilters: true
        }));
        map.off('row-hover', onMapRowHover);
        map.off('row-leave', onMapRowLeave);
        map.off('section-hover', onMapSectionHover);
        map.off('section-leave', onMapSectionLeave);
        map.off('zoomend', onMapZoomEnd);
        // sync map section highlighting
        map === null || map === void 0 || map.resetSelected();
        setMapMetadataLoaded(false);
      });
    };
  }, [mapInitialized]);
  useEffect(function () {
    map === null || map === void 0 || map.setSections(sections);
    // recompute tooltips
    map === null || map === void 0 || map.on('section-hover', onMapSectionHover);
  }, ["".concat(sections)]);
  useEffect(function () {
    // clear selected section if no longer available
    selectedSectionsMbi === null || selectedSectionsMbi === void 0 || selectedSectionsMbi.map(function (_ref) {
      var sectionId = _ref.sectionId,
        mbi = _ref.mbi;
      if (sections.find(function (s) {
        return s.sectionId === sectionId;
      })) return;
      // unselect the section
      map === null || map === void 0 || map.setSelection(mbi, false);
      onSectionSelectAction === null || onSectionSelectAction === void 0 || onSectionSelectAction({
        id: "".concat(sectionId),
        hasSectionBeenManuallyFiltered: true
      });
    });
    updateInspectorSelectedSections();
  }, ["".concat(selectedSectionsMbi), "".concat(sections)]);
  useEffect(function () {
    // store mbi values
    setSelectedSectionsMbi(selectedSections.map(function (sectionId) {
      var _sections$find$mbi, _sections$find;
      return {
        sectionId: sectionId,
        mbi: (_sections$find$mbi = (_sections$find = sections.find(function (s) {
          return s.sectionId === sectionId;
        })) === null || _sections$find === void 0 ? void 0 : _sections$find.mbi) !== null && _sections$find$mbi !== void 0 ? _sections$find$mbi : ''
      };
    }));
  }, ["".concat(selectedSections)]);
  useEffect(function () {
    map === null || map === void 0 || map.resetSelected();
    if (selectedSectionsMbi.length) map === null || map === void 0 || map.syncSelectedSections(selectedSectionsMbi.map(function (s) {
      return s.mbi;
    }));
    if (selectedRows.length) map === null || map === void 0 || map.syncSelectedRows(selectedRows);
    highlightAllRowsForASection(selectedSectionsMbi);
  }, ["".concat(selectedSectionsMbi), "".concat(selectedRows)]);
  useEffect(function () {
    if (selectedSectionsMbi.length || selectedRows.length) return;
    map === null || map === void 0 || map.setFocus(null, {
      animate: DEFAULT_CLICK_BEHAVIOR.animate,
      faceStage: DEFAULT_CLICK_BEHAVIOR.faceStage,
      persistFocusOptions: true
    });
  }, [selectedSectionsMbi.length, selectedRows.length]);
  useEffect(function () {
    var _map$metadata2;
    if (map !== null && map !== void 0 && (_map$metadata2 = map.metadata) !== null && _map$metadata2 !== void 0 && _map$metadata2.sections.length) setMapMetadataLoaded(!!(map !== null && map !== void 0 && map.metadata));
  }, [map === null || map === void 0 || (_map$metadata3 = map.metadata) === null || _map$metadata3 === void 0 ? void 0 : _map$metadata3.sections.length]);
  return {
    map: map,
    mapElement: mapElement,
    mapInitialized: mapInitialized,
    mapMetadataLoaded: mapMetadataLoaded,
    onMapSectionClickFromListing: onMapSectionClickFromListing,
    onMapResetClick: onMapResetClick,
    setSectionPriceTooltip: setSectionPriceTooltip,
    onMapRevertTicketSelectionZoom: onMapRevertTicketSelectionZoom
  };
}
export default useVenueMapState;